export default __webpack_public_path__ + "static/media/22.36c8f68a.jpg";